export default "<ms-header></ms-header>\n<div style=\"min-height:77vh;\">\n<router-outlet></router-outlet>\n</div>\n<ms-footer></ms-footer>";